import React from 'react';
import { addDays, format } from 'date-fns';
import { CalendarClockIcon, SunIcon } from 'lucide-react';
import { timeOffEntries } from '../../data/timeOff';
import type { Navigate } from '../../types/hr';
import { displayName, getEmployee } from '../../utils/employees';
import { TODAY, formatDays, formatRange } from '../../utils/format';
import { isOutOn } from '../../utils/timeOff';
import { ENTRY_BADGE } from '../dashboard/WhosOutCard';
import { Avatar } from '../ui/Avatar';
import { Badge } from '../ui/Badge';
import { Card } from '../ui/Card';
export function OutList({
  onNavigate
}: {
  onNavigate: Navigate;
}) {
  const todayIso = format(TODAY, 'yyyy-MM-dd');
  const limitIso = format(addDays(TODAY, 30), 'yyyy-MM-dd');
  const today = timeOffEntries.filter(e => isOutOn(e, TODAY));
  const upcoming = timeOffEntries.filter(e => e.start > todayIso && e.start <= limitIso).sort((a, b) => a.start.localeCompare(b.start));
  const groups = [{
    title: 'Out today',
    icon: SunIcon,
    items: today
  }, {
    title: 'Coming up · next 30 days',
    icon: CalendarClockIcon,
    items: upcoming
  }];
  return <div className="grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-989" data-mp="3jbpg6y281s5h">
      {groups.map(g => <Card key={g.title} title={g.title} subtitle={`${g.items.length} people`} icon={g.icon} bodyClassName="px-3 pb-3" data-id="element-990" data-mp="3ej609ug2akxi">
          <ul className="space-y-0.5" data-id="element-991" data-mp="39kbkz2hazei5">
            {g.items.map(entry => {
          const emp = getEmployee(entry.employeeId);
          if (!emp) return null;
          return <li key={entry.id} data-id="element-992" data-mp="30ilhuze26r4j">
                  <button type="button" onClick={() => onNavigate({
              page: 'profile',
              employeeId: emp.id,
              tab: 'timeoff'
            })} className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left transition hover:bg-canvas/70" data-id="element-993" data-mp="30mj0ljwq5gnw">
                    <Avatar name={displayName(emp)} seed={emp.id} size="sm" data-id="element-994" data-mp="ouvllj40qhgw" />
                    <span className="min-w-0 flex-1" data-id="element-995" data-mp="ossyb6u932fv">
                      <span className="block truncate text-sm font-medium text-navy" data-id="element-996" data-mp="2j9sy6ovwo6w8">{displayName(emp)}</span>
                      <span className="block truncate text-xs text-muted" data-id="element-997" data-mp="2o2cdbqa8ra35">
                        {formatRange(entry.start, entry.end)} · {formatDays(entry.days)}
                      </span>
                    </span>
                    <Badge tone={ENTRY_BADGE[entry.tone]} data-id="element-998" data-mp="2ec0wx49df8fd">{entry.policyLabel}</Badge>
                  </button>
                </li>;
        })}
          </ul>
        </Card>)}
    </div>;
}